import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestDeleteDriver } from "./deleteDriver.request";
import { DeleteDriverResponse } from "./deleteDriver.types";

const useDeleteDriver = (
  options?: MutationOptions<DeleteDriverResponse, ApiServiceError<ApiError>>
) => {
  const refetchDrivers = useRefetchQuery(["driver"]);

  return useMutation({
    mutationFn: requestDeleteDriver,
    ...options,
    onSuccess: (...args) => {
      refetchDrivers();
      options?.onSuccess?.(...args);
    }
  });
};

export default useDeleteDriver;
